import { Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import AgrisudLogo from '../../assets/images/logo/agrisud-logo.png';
import styles from './landing-page-footer.module.scss';

const LandingPageFooter: React.FC<{ t: any }> = ({ t }) => {
  return (
    <footer>
      <div className={styles['admin-site-footer']}>
        <Row>
          <Col md={12} className={styles['footer-icons-wrapper']}>
            <a href="https://agrisud.int.norsys-afrique.ma/web/" target="_blank" rel="noreferrer">
              <img width="130" src={AgrisudLogo} alt="agrisud-footer-logo" />
            </a>
            <div className={styles['footer-icons']}>
              <a href="https://www.facebook.com/agrisudinternational" target="_blank" rel="noreferrer">
                <i className={`${styles['footer-icon']} fa fa-facebook`}></i>
              </a>
              <a href="https://www.youtube.com/channel/UCh2gpZfUz0E6uiKsxMcMiog" target="_blank" rel="noreferrer">
                <i className={`${styles['footer-icon']} fa fa-youtube-play`}></i>
              </a>
              <a href="https://twitter.com/Agrisud_ONG" target="_blank" rel="noreferrer">
                <i className={`${styles['footer-icon']} fa fa-twitter`}></i>
              </a>
              <a href="https://www.linkedin.com/company/agrisud-international" target="_blank" rel="noreferrer">
                <i className={`${styles['footer-icon']} fa fa-linkedin-in`}></i>
              </a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className={styles['footer-links']}>
            <span className={styles['footer-link']}>
              <Link to={`${process.env.PUBLIC_URL}/mentions-legales`}>{t('footer.legal_informarion')}</Link>
            </span>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default translate(LandingPageFooter);
